import React from 'react'
import LeadError from '../LeadError'
import Input from 'app/theme/forms/Input'
import Radio from 'app/theme/forms/Radio'
import { Spinner } from 'app/theme/Spinner'

const resetHighestLandedStep = (steps, step, setHighestLandedStep) => {
  setHighestLandedStep(steps.findIndex(s => s === step))
}

export default function LeadOccasion(props) {
  const { occasions, occasionsIsLoading, data, setData, errors, setErrors, setHighestLandedStep, step, steps } = props

  const occasionId = data.occasion?.id

  return (
    <div>
      <div className="font-light">
        {occasionsIsLoading ? (
          <div className="">
            <Spinner className="text-blue w-10 h-10 mx-auto my-5"/>
          </div>
        ) : occasions.length ? (
<>
            {occasions.map((occasion, index) => (
              <div
                key={occasion.id}
                className={[
                  'px-8 py-3',
                  index !== 0 && 'border-t border-gray-300',
                ]}
              >
                {occasion.code === 'other' ? (
                  <div className="flex items-center">
                    <Radio
                      name="occasion"
                      checked={occasionId === occasion.id}
                      onChange={checked => {
                        setErrors(false)
                        setData(prev => ({
                          ...prev,
                          occasion,
                        }))
                      }}
                    />
                    <div className="flex-1">
                      <Input
                        value={data.occasion_other}
                        placeholder="Other"
                        className="border-gray-400 focus:border-blue"
                        onChange={occasion_other => {
                          setErrors(false)
                          setData(prev => ({
                            ...prev,
                            occasion: occasion_other ? occasion : null,
                            occasion_other,
                          }))
                        }}
                      />
                    </div>
                  </div>
                ) : (
                  <Radio
                    name="occasion"
                    label={occasion.name}
                    checked={occasionId === occasion.id}
                    onChange={_ => {
                      setErrors(false)
                      setData(prev => ({
                        ...prev,
                        occasion,
                      }))
                      if (occasion.name === 'Corporate') {
                        resetHighestLandedStep(steps, step, setHighestLandedStep)
                      }
                    }}
                  />
                )}
              </div>
            ))}
            {errors?.occasion && (
              <div className="font-bold px-8 py-3 border-t border-gray-300">
                <LeadError
                  message={errors.occasion}
                />
              </div>
            )}
            {errors?.occasion_other && (
              <div className="font-bold px-8 py-3 border-t border-gray-300">
                <LeadError
                  message={errors.occasion_other}
                />
              </div>
            )}
          </>
        ) : (
          <div className="font-bold px-8 py-3 text-center text-red-600">
            An unexpected error occurred. Please try to submit your details again in a few minutes.
          </div>
        )}
      </div>
    </div>
  )
}
